import { z } from "zod";

export const qlikAppSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable().optional(),
  published: z.boolean().optional(),
  spaceId: z.string().nullable().optional(),
  spaceName: z.string().nullable().optional(),
  ownerId: z.string().nullable().optional(),
  ownerName: z.string().nullable().optional(),
  createdAt: z.string().nullable().optional(),
  updatedAt: z.string().nullable().optional(),
  canUpdate: z.boolean().optional(),
});

export type QlikApp = z.infer<typeof qlikAppSchema>;

export const listQlikAppsResponseSchema = z.object({
  data: z.array(qlikAppSchema),
});

export type ListQlikAppsResponse = z.infer<typeof listQlikAppsResponseSchema>;
